import { ContextMenuItem } from "@/components/ui";
import { History } from "lucide-react";

interface MatterSubItemEventLogsContextMenuProps {
  onOpenEventLogs: () => void;
}

export const MatterSubItemEventLogsContextMenu = ({
  onOpenEventLogs,
}: MatterSubItemEventLogsContextMenuProps) => {
  return (
    <ContextMenuItem onSelect={onOpenEventLogs}>
      <History />
      Event log
    </ContextMenuItem>
  );
};
